import template from "./message-notifications.html";
import "./message-notifications.less";

// supportInfo
export function controller(
	$scope,
	appState,
	api,
	loadingService,
	toastr,
	eventBus,
	config,
	$state
) {
	const ctrl = this;

	ctrl.sendMessage = sendMessage;
	ctrl.$onInit = onInit;
	ctrl.hasMessages = false;
	ctrl.goTo = goTo;

	function onInit() {
		ctrl.form = appState.forms.selected;
		ctrl.support = config.support;
	}

	function sendMessage() {
		const params = { Message: ctrl.message };

		const promise = api.post("api/feedback", params).then(() => {
			toastr.success("Thank you for your feedback.");

			ctrl.message = null;
		});

		loadingService.watch(promise, "Sending Feedback...");
	}

	function goTo(route) {
		$state.go(route);
	}
}

export default angular
	.module("vesl.components.message-notifications", [])
	.component("messageNotifications", {
		template,
		controller,
		bindings: {
			hasMessages: "="
		}
	}).name;
